module.exports = __webpack_public_path__ + "img/529006f.png";